import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    calloutTitle: {
        color: defaultPalette.primary.main,
        fontWeight: 'bold',
        fontSize: '1rem',
        lineHeight: '1.5rem',
    },
})
